<router-outlet></router-outlet>
<app-message #message></app-message>
<app-inactivity-alert 
  #inactivityAlert
  [visible]="showInactivityAlert"
  [countdown]="60"
  (onContinue)="onContinueSession()"
  (onTimeout)="onInactivityTimeout()">
</app-inactivity-alert>
<ngx-loading-bar></ngx-loading-bar>
